import { hasEditorDoc, type EditorDoc } from "@/lib/doc/doc-types";
import { BlockDocRenderer } from "@/components/doc/BlockDocRenderer";
import { CraftRenderer } from "@/components/craft/CraftRenderer";
import { hasCraftContent } from "@/lib/craft/serialize";
import type { ArticleBlock } from "@/lib/types/content";
import { slugifyHeading } from "@/lib/craft/headings";

type ArticleDocBodyProps = {
  editorDoc?: unknown;
  craftState?: unknown;
  craftCustomCss?: string;
  body?: ArticleBlock[];
};

function renderLegacyBlock(b: ArticleBlock, i: number) {
  switch (b.type) {
    case "h2":
      return (
        <h2 key={i} id={slugifyHeading(b.text)} className="mt-12 scroll-mt-28 text-2xl font-bold tracking-tight text-primary md:text-3xl">
          {b.text}
        </h2>
      );
    case "h3":
      return <h3 key={i} className="mt-8 text-xl font-bold tracking-tight text-primary">{b.text}</h3>;
    case "p":
      return <p key={i} className="mt-5 text-lg leading-relaxed text-foreground/85 md:text-[17px]">{b.text}</p>;
    case "ul":
      return (
        <ul key={i} className="mt-5 space-y-2.5">
          {b.items.map((it, j) => (
            <li key={j} className="flex gap-3 text-lg leading-relaxed text-foreground/85">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      );
  }
}

export function ArticleDocBody({ editorDoc, craftState, craftCustomCss, body }: ArticleDocBodyProps) {
  if (hasEditorDoc(editorDoc)) {
    return <BlockDocRenderer doc={editorDoc as EditorDoc} />;
  }
  if (hasCraftContent(craftState as string | object)) {
    return (
      <CraftRenderer
        craftState={craftState}
        craftCustomCss={craftCustomCss}
      />
    );
  }
  return <>{(body ?? []).map(renderLegacyBlock)}</>;
}
